import React from 'react';
import Button from 'components/common/Button';
import Icon from 'components/common/Icon';


export default ({ name, address, email, tel, fax, twitter, facebook, instagram, youtube }) => (
  <footer className="bg-faded-3 p-5">
    <div className="container">
      <div className="row no-gutters">
        <div className="col-lg-10 offset-lg-1 d-flex align-items-md-center align-items-start flex-column flex-md-row">
          <div className="footer-info">
            <p className="wide font-weight-normal mb-0">
              {name && <span>{name}<br/></span>}
              {address && <span>{address}<br/></span>}
              <span className="d-flex flex-column flex-md-row">
                {email && <span className="mr-md-3">{email}</span>}
                {tel && <span className="mr-md-3">Tel: {tel}</span>}
                {fax && <span>Fax: {fax}</span>}
              </span>
            </p>
          </div>
          <div className="footer-social text-right d-flex justify-content-end mt-md-0 mt-45">
            { twitter   && <a rel="noopener noreferrer" href={twitter}   target="_blank" className="mr-2"><Button shape="circle" color="info" btnStyle="transparent"><Icon icon="twitter"/></Button></a>}
            { facebook  && <a rel="noopener noreferrer" href={facebook}  target="_blank" className="mr-2"><Button shape="circle" color="info" btnStyle="transparent"><Icon icon="facebook"/></Button></a> }
            { youtube   && <a rel="noopener noreferrer" href={youtube}   target="_blank" className="mr-2"><Button shape="circle" color="info" btnStyle="transparent"><Icon icon="youtube"/></Button></a> }
            { instagram && <a rel="noopener noreferrer" href={instagram} target="_blank"><Button shape="circle" color="info" btnStyle="transparent"><Icon icon="instagram"/></Button></a> }
          </div>
        </div>
      </div>
      <div className="text-md-center mt-md-55 mt-45">
        <small className="text-muted">
          {/*<a className="font-weight-normal" href="/terms-of-use">Terms of use</a> | <a className="font-weight-normal mr-4" href="/privacy-policy">Privacy Policy</a>*/}
          <span>&copy; 2017 All rights reserved to Guesty, Inc.</span>
        </small>
      </div>
    </div>
  </footer>
);


// WEBPACK FOOTER //
// ./src/components/Footer.js